import { TemplateConfig } from '../types';

export const peachBlossomBloomConfig: TemplateConfig = {
  id: 'peach-blossom-bloom',
  name: '桃花朵朵牌阵',
  description: '分析当前的桃花状况与发展方向',
  cardCount: 10,

  fieldDefaults: {
    title: '桃花朵朵牌阵',
    customerQuestion: '**分析我的桃花运的情况。**',
    cardPlaceholders: [
      '请输入第 1 行第 1 张牌',
      '请输入第 2 行第 1 张牌',
      '请输入第 2 行第 2 张牌',
      '请输入第 2 行第 3 张牌',
      '请输入第 3 行第 1 张牌',
      '请输入第 3 行第 2 张牌',
      '请输入第 4 行第 1 张牌',
      '请输入第 4 行第 2 张牌',
      '请输入第 4 行第 3 张牌',
      '请输入第 5 行第 1 张牌'
    ],
    cardInfos: [
      '自身对情感的需求',
      '明确自身恋爱方向',
      '潜在桃花外形特质，分析时请尽量具体，如：肤色偏白、身高175左右、瓜子脸之类',
      '桃花的性格和状态',
      '桃花出现的时间，以及相遇的大概时间特点，比如季节或者月份',
      '桃花出现的地点，以及场合，比如是正式或非正式场合',
      '近期和桃花发展的感情趋势，关系初期',
      '中期和桃花发展的感情趋势，发展过程中的状态',
      '远期和桃花发展的感情趋势，长远趋势',
      '应该怎么做及建议'
    ]
  },

  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],

  generateOptions: {
    normal: true,
    thinking: true
  },

  ui: {
    color: '#ff85c0',
    backgroundColor: '#fff0f6',
    icon: '💮'
  }
};
